<template>
  <div>
    <section class="notice-wrap">
      <div class="notice-header">
        <p class="notice-header-title">{{ detailsData.noticeTitle }}</p>
        <p class="notice-header-time">时间：{{ detailsData.createDate }}</p>
      </div>
      <div class="notice-con">
        <!-- 资质认证 -->
        <div v-if="detailsData.noticeType==101" class="notice-con-item">
          <div v-if="detailsData.isMark==1">
            <p class="item-txt">您好：您所在的{{ detailsData.noticeModuleVal.companyName }}资质认证已通过,感谢您的支持。</p>
          </div>
          <div v-if="detailsData.isMark==2">
            <p class="item-txt">您好：您所在的{{ detailsData.noticeModuleVal.companyName }}资质认证申诉已通过，感谢您的支持。</p>
          </div>
          <div v-if="detailsData.isMark==3">
            <p class="item-txt">您好：您所在的{{ detailsData.noticeModuleVal.companyName }}资质认证资料已变更成功，感谢您的支持。</p>
          </div>
          <div v-if="detailsData.isMark==4">
            <p class="item-txt">非常抱歉，您申请的资质认证申请没有通过，请完善您的资料，感谢您的支持。</p>
          </div>
        </div>
        <!-- 订单 -->
        <div v-if="detailsData.noticeType==102" class="notice-con-item">
          <div v-if="detailsData.isMark==1">
            <p class="item-txt">
              您好：您所在的{{ detailsData.noticeModuleVal.supplyCompany }}与{{ detailsData.noticeModuleVal.demandCompany }}于{{ detailsData.noticeModuleVal.createDate }} 达成了交易。
            </p>
            <p class="item-txt">订单编号：{{ detailsData.noticeModuleVal.orderNum }}</p>
          </div>
          <div v-if="detailsData.isMark==2">
            <p class="item-txt">您好：{{ detailsData.noticeModuleVal.demandCompany }}公司想要租用{{ detailsData.noticeModuleVal.storageType }}。 出价{{ detailsData.noticeModuleVal.money }}元。</p>
          </div>
          <div v-if="detailsData.isMark==3">
            您好：您的订单已成功取消；订单编号：{{ detailsData.noticeModuleVal.orderNum }}
          </div>
          <div v-if="detailsData.isMark==4">
            您好：您的订单已成功取消；订单编号：{{ detailsData.noticeModuleVal.orderNum }}
          </div>
          <div v-if="detailsData.isMark==5">
            您好：订单拒绝成功 订单编号：{{ detailsData.noticeModuleVal.orderNum }}
          </div>
          <div v-if="detailsData.isMark==6">
            您好：您的订单已被拒绝；订单编号：{{ detailsData.noticeModuleVal.orderNum }}
          </div>
          <div v-if="detailsData.isMark==7">
            <p class="item-txt">
              您好：您所在的{{ detailsData.noticeModuleVal.supplyCompany }}与{{ detailsData.noticeModuleVal.demandCompany }}于{{ detailsData.noticeModuleVal.createDate }} 达成了交易。
            </p>
            <p class="item-txt">订单编号：{{ detailsData.noticeModuleVal.orderNum }}</p>

          </div>
        </div>
        <!-- 运单生成 -->
        <div v-if="detailsData.noticeType==103" class="notice-con-item">
          <div v-if="detailsData.isMark==1">
            <p class="item-txt">
              您好：您的xxx订单正在运输中
            </p>
            <p class="item-txt">订单的详情信息青岛订单列表中查看</p>
          </div>
          <div v-if="detailsData.isMark==2">
            <p class="item-txt">
              您好：您的xxx订单已完成
            </p>
            <p class="item-txt">订单的详情信息青岛订单列表中查看</p>
          </div>
          <div v-if="detailsData.isMark==3">
            <p class="item-txt">
              您好：您的xxx订单在运输途中，出现了一些问题，详情信息请咨询客服。
            </p>
          </div>
        </div>
        <!-- 报价 -->
        <div v-if="detailsData.noticeType==104" class="notice-con-item">
          <div v-if="detailsData.isMark==1">
            <p class="item-txt">
              您好：您发布的{{ detailsData.noticeModuleVal.weight }}吨{{ detailsData.noticeModuleVal.goodsTypeLabel }}运输任务，
              {{ detailsData.noticeModuleVal.companyName }}愿意出价{{ detailsData.noticeModuleVal.offerPrice }}元承运。
            </p>
            <p class="item-txt">
              运力方联系人：{{ detailsData.noticeModuleVal.companyContact }}， 联系电话：{{ detailsData.noticeModuleVal.contactTel }}
            </p>
          </div>
          <div v-if="detailsData.isMark==2">
            <p class="item-txt">您好：{{ detailsData.noticeModuleVal.companyName }}邀请您参与报价</p>
            <p class="item-txt" />货源方联系人：{{ detailsData.noticeModuleVal.nickName }} 联系电话：{{ detailsData.noticeModuleVal.contactTel }}
          </div>
          <div v-if="detailsData.isMark==3">
            您好：您对XX货源 报价成功  货源方联系人：xxx 联系电话：xxxx
          </div>
          <div v-if="detailsData.isMark==4">
            您好：您对 "{{ detailsData.noticeModuleVal.companyName }}" 发布的 "{{ detailsData.noticeModuleVal.goodsTypeLabel }}"重量:{{ detailsData.noticeModuleVal.weight }}吨,报价成功
          </div>
        </div>
        <!-- 预约 -->
        <div v-if="detailsData.noticeType==105" class="notice-con-item">
          <div v-if="detailsData.isMark==1">
            <p class="item-txt">您好：位于{{ detailsData.noticeModuleVal.storageLocation }}的仓库主人已同意了您的看仓申请。</p>
            <p class="item-txt">仓储方联系人：{{ detailsData.noticeModuleVal.contactMan }}, 联系电话：{{ detailsData.noticeModuleVal.tel }}</p>
          </div>
          <div v-if="detailsData.isMark==2">
            <p class="item-txt">您好：您的看仓邀请已发送到{{ detailsData.noticeModuleVal.demand.companyName }}
            </p>
          </div>
          <div v-if="detailsData.isMark==3">
            <p class="item-txt">
              {{ detailsData.noticeModuleVal.companyName }}有{{ detailsData.noticeModuleVal.storageType }}的存储需求。希望了解您的仓库情况
            </p>
          </div>
          <div v-if="detailsData.isMark==4">
            <p class="item-txt">仓库主人邀请您前往{{ detailsData.noticeModuleVal.storageLocation }}实地考察</p>
            <p class="item-txt">仓储方联系人：{{ detailsData.noticeModuleVal.LinkMan }} 联系电话：{{ detailsData.noticeModuleVal.Telephone }}</p>
          </div>
        </div>
        <!-- 司机任务 -->
        <div v-if="detailsData.noticeType==106" class="notice-con-item">
          <div v-if="detailsData.isMark==1">
            <p class="item-txt">您有新的任务	，请查看您的任务列表。</p>
          </div>
          <div v-if="detailsData.isMark==2">
            <p class="item-txt">由于您没有接受任务指派	，xxx 号任务已经逾期</p>
          </div>
          <div v-if="detailsData.isMark==3">
            <p class="item-txt" />
          </div>
          <div v-if="detailsData.isMark==4">
            <p class="item-txt">
              您已经接收任务
            </p>
            <p class="item-txt">
              起运地： 目的地货物类型：xxx	：  任务号：xxx  运单号:xxxx
            </p>
            <p class="item-txt">
              货物重量：xxx  要求起运时间；要求到达时间	；
            </p>
          </div>
          <div v-if="detailsData.isMark==5">
            <p class="item-txt">
              您的任务已完成
            </p>
            <p class="item-txt">
              起运地： 目的地货物类型：xxx	：  任务号：xxx  运单号:xxxx
            </p>
            <p class="item-txt">
              货物重量：xxx  要求起运时间；要求到达时间	；
            </p>
          </div>
          <div v-if="detailsData.isMark==6">
            <p class="item-txt">
              您拒绝了以下任务
            </p>
            <p class="item-txt">
              起运地： 目的地货物类型：xxx	：  任务号：xxx  运单号:xxxx
            </p>
            <p class="item-txt">
              货物重量：xxx  要求起运时间；要求到达时间	；
            </p>
          </div>
        </div>
        <div v-if="detailsData.noticeType==107" class="notice-con-item">107</div>
        <div v-if="detailsData.noticeType==108" class="notice-con-item">108</div>
        <div v-if="detailsData.noticeType==109" class="notice-con-item">109</div>
        <div v-if="detailsData.noticeType==110" class="notice-con-item">
          <div v-if="detailsData.isMark==1">
            <p class="item-txt">您向{{ detailsData.noticeModuleVal.companyName }}推荐{{ detailsData.noticeModuleVal.relationName }}成功</p>
          </div>
          <div v-if="detailsData.isMark==2">
            <!--<el-table-->
            <!--ref="recommendTable"-->
            <!--:data="recommendTable"-->
            <!--tooltip-effect="dark"-->
            <!--style="width: 100%"-->
            <!--@selection-change="handleSelectionChange"-->
            <!--&gt;-->
            <!--<el-table-column-->
            <!--type="selection"-->
            <!--width="55"-->
            <!--/>-->
            <!--<el-table-column-->
            <!--label="日期"-->
            <!--width="120"-->
            <!--&gt;-->
            <!--<template slot-scope="scope">{{ scope.row.date }}</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--prop="name"-->
            <!--label="姓名"-->
            <!--width="120"-->
            <!--/>-->
            <!--<el-table-column-->
            <!--prop="address"-->
            <!--label="地址"-->
            <!--show-overflow-tooltip-->
            <!--/>-->
            <!--</el-table>-->
            <p class="item-title">{{ detailsData.noticeModuleVal.companyName }}向您推荐了如下联系人</p>

            <section class="recommendLog-wrap">
              <article class="recommendLog-title">
                <ul>
                  <li>
                    <el-checkbox v-model="allSelectionRecommend" @change="selectionRecommend()" />
                  </li>
                  <li>公司名称</li>
                  <li>公司地址</li>
                  <li>联系人</li>
                  <li>性别</li>
                  <li>联系电话</li>
                </ul>
              </article>
              <!--表格内容-->
              <article class="recommendLog-body">
                <template v-for="(item,itemIndex) in RecommendData">
                  <div :key="itemIndex" class="body-item">
                    <ul>
                      <li>
                        <el-checkbox ref="selBtn" v-model="item.selection" @change="recommendChange(item)" />
                      </li>
                      <li>{{ item.companyName }}</li>
                      <li>{{ item.companyAddress }}</li>
                      <li>{{ item.relationName }}</li>
                      <li>{{ item.relationSex }}</li>
                      <li>{{ item.relationPhone }}</li>
                    </ul>
                  </div>
                </template>
              </article>
            </section>
            <!--分页-->
            <article class="main-pagination">
              <el-pagination
                :current-page="pagination.pageNo"
                :total="pagination.total"
                :page-size="pagination.pageSize"
                layout="prev, pager, next, jumper,total, sizes"
                @current-change="changeCurrent"
                @size-change="changeSize"
              />
            </article>
          </div>
        </div>
        <div v-if="detailsData.noticeType==111" class="notice-con-item">
          <div v-if="detailsData.isMark==1">
            <p class="item-txt">
              您好：您的司机资质认证已通过	，感谢您的支持
            </p>
          </div>
          <div v-if="detailsData.isMark==2">
            <p class="item-txt">
              非常抱歉，您的司机资质认证没有通过	，请完善您的资料，	感谢您的支持
            </p>
          </div>
          <div v-if="detailsData.isMark==3">
            <p class="item-txt">
              您好：您的司机资质认证申诉已通过	，感谢您的支持
            </p>
          </div>
        </div>
        <!--{{ detailsData.noticeContent }}-->
      </div>
      <div class="notice-btn-box">
        <div
          v-if="ifHidden"
          class="notice-btn"
          @click="
            noticeDetails(
              detailsData.noticeType,
              detailsData.isMark,
              detailsData.id,
              detailsData
            )
          "
        >
          查看详情
        </div>
        <div v-if="ifAccept" class="notice-btn" @click="recommendAccept(detailsData,0)">接受</div>
        <div v-if="ifAccept" class="notice-btn" @click="recommendAccept(detailsData,1)">拒绝</div>
        <div class="notice-btn-return" @click="noticeReturn()">
          返回
        </div>
      </div>
    </section>
  </div>
</template>

<script type="text/ecmascript-6">
import { addRecommend, getRecommendList } from '@/api/personal/user/news-notice/index.js'
import { Page } from '@/utils/commonDataModel'
export default {
  props: {
    detailsCon: {
      type: [Object],
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      // 表格分页
      pagination: new Page(),
      // 详情
      detailsData: {},
      ifHidden: true,
      ifAccept: false,
      // 推荐联系人数据
      RecommendData: [
        {
          hidden: false,
          selection: false,
          companyName: '',
          companyAddress: '',
          relationName: '',
          relationSex: '',
          relationPhone: ''
        }
      ],
      // 推荐联系人全选
      allSelectionRecommend: false,
      // 多选-选中的id
      recommendSelection: []
    }
  },
  created() {
    this.detailsData = this.detailsCon
    console.log(this.detailsData)
    // 获取消息通知类型 判断按钮是否显示
    if (this.detailsData.noticeType == 110 || this.detailsData.noticeType == 106 || this.detailsData.noticeType == 111 || this.detailsData.noticeType == 104) {
      this.ifHidden = false
    }
    if (this.detailsData.noticeType == 102 && this.detailsData.isMark == 5) {
      this.ifHidden = false
    }
    // 判断是否是110状态  展示被推荐联系人列表
    this.recommendListFun()
  },
  methods: {
    // 判断是否是110状态  展示被推荐联系人列表
    recommendListFun() {
      if (this.detailsData.noticeType == 110 && this.detailsData.isMark == 2) {
        this.ifAccept = true
        let objId = eval('(' + this.detailsData.noticeModuleId + ')')
        objId = {
          list: objId.list.replace(/\[|]/g, ''),
          ids: objId.ids.replace(/\[|]/g, '')
        }
        getRecommendList(objId).then(res => {
          console.log(res)
          this.RecommendData = res.result
        })
      }
    },
    // 详情返回列表
    noticeReturn() {
      this.$emit('detailsRet', false)
    },
    // 查看详情
    noticeDetails(data, isMark, id, con) {
      // 用来关闭详情
      this.$emit('detailsRet', false)
      switch (data) {
        case '101':
          if (isMark == 1) {
            this.$router.push({
              name: 'QualificationsAuthen',
              params: { noticeId: id, noticeMark: isMark, data: con }
            })
          } else if (isMark == 2) {
            this.$router.push({
              name: 'QualificationsAuthen',
              params: { noticeId: id, noticeMark: isMark, data: con }
            })
          } else if (isMark == 3) {
            this.$router.push({
              name: 'QualificationsAuthen',
              params: { noticeId: id, noticeMark: isMark, data: con }
            })
          } else if (isMark == 4) {
            this.$router.push({
              name: 'QualificationsAuthen',
              params: { noticeId: id, noticeMark: isMark, data: con }
            })
          }
          break // 资质认证
        case '102':
          if (isMark == 1) {
            this.$router.push({
              name: 'OrderList',
              params: { noticeId: id, noticeMark: isMark, data: con }
            })
          } else if (isMark == 2) {
            this.$router.push({
              name: 'OrderList',
              params: { noticeId: id, noticeMark: isMark, data: con }
            })
          } else if (isMark == 3) {
            this.$router.push({
              name: 'OrderList',
              params: { noticeId: id, noticeMark: isMark, data: con }
            })
          } else if (isMark == 4) {
            this.$router.push({
              name: 'OrderList',
              params: { noticeId: id, noticeMark: isMark, data: con }
            })
          } else if (isMark == 5) {
            this.$router.push({
              name: 'OrderList',
              params: { noticeId: id, noticeMark: isMark, data: con }
            })
          } else if (isMark == 6) {
            this.$router.push({
              name: 'OrderList',
              params: { noticeId: id, noticeMark: isMark, data: con }
            })
          } else if (isMark == 7) {
            this.$router.push({
              name: 'OrderList',
              params: { noticeId: id, noticeMark: isMark, data: con }
            })
          }
          break // 订单列表
        case '103':
          if (isMark == 1) {
            this.$router.push({
              name: 'TransportList',
              params: { noticeId: id, noticeMark: isMark, data: con }
            })
          } else if (isMark == 2) {
            this.$router.push({
              name: 'TransportList',
              params: { noticeId: id, noticeMark: isMark, data: con }
            })
          } else if (isMark == 3) {
            this.$router.push({
              name: 'TransportList',
              params: { noticeId: id, noticeMark: isMark, data: con }
            })
          }
          break // 运单生成
        case '104':
          if (isMark == 1) {
            // 报价成功
            this.$router.push({
              name: 'GoodsList',
              params: { noticeId: id, noticeMark: isMark, data: con }
            })
          } else if (isMark == 2) {
            // 被邀报价
            this.$router.push({
              name: 'InvitatedList',
              params: { noticeId: id, noticeMark: isMark, data: con }
            })
          } else if (isMark == 3) {
            // 参与报价（暂无）
            this.$router.push({
              name: 'GoodsList',
              params: { noticeId: id, noticeMark: isMark, data: con }
            })
          }
          break // 报价
        case '105':
          if (isMark == 1) {
            // 预约成功
            this.$router.push({
              name: 'MyAppointment',
              params: { noticeId: id, noticeMark: isMark, data: con }
            })
          } else if (isMark == 2) {
            // 邀约成功
            this.$router.push({
              name: 'MyInvitation',
              params: { noticeId: id, noticeMark: isMark, data: con }
            })
          } else if (isMark == 3) {
            // 有人预约
            this.$router.push({
              name: 'CoverAppointment',
              params: { noticeId: id, noticeMark: isMark, data: con }
            })
          } else if (isMark == 4) {
            // 邀请预约
            this.$router.push({
              name: 'CoverInvitation',
              params: { noticeId: id, noticeMark: isMark, data: con }
            })
          }
          break // 预约
        case '110':
          this.$router.push({
            name: 'contacts',
            params: { noticeId: id, noticeMark: isMark }
          })
          break // 联系人
        default:
          return
      }
    },

    // (接受//拒绝)联系人
    recommendAccept(data, val) {
      const ids = this.RecommendData.filter(item => item.selection).map(item => item.id)
      const objId = eval('(' + data.noticeModuleId + ')')
      const objData = {
        list: ids.join(','),
        ids: objId.ids.replace(/\[|]/g, ''),
        inState: val
      }
      if (!this.RecommendData.selection) {
        this.$message({
          message: '请选择要接受的数据',
          type: 'warning'
        })
        return
      }
      addRecommend(objData).then(res => {
        console.log(res)
        if (objData.inState == 0) {
          this.$message({
            type: 'success',
            message: '已接受!'
          })
        } else {
          this.$message({
            type: 'success',
            message: '已拒绝!'
          })
        }
        this.recommendListFun()
      })
    },
    // 推荐联系人全选
    selectionRecommend() {
      this.RecommendData.forEach(i => {
        if (i.selection !== this.allSelectionRecommend) {
          i.selection = !i.selection
        }
      })
    },
    // 推荐联系人 子项多选
    recommendChange() {
      //                                         每一项都是true  则返回true
      this.allSelectionRecommend = this.RecommendData.every(i => i.selection)
      this.RecommendData.selection = !this.RecommendData.selection
    },
    // 分页-第几页
    changeCurrent(current) {
      this.pagination.pageNo = current
    },
    // 分页-每页多少条
    changeSize(size) {
      this.pagination.pageSize = size
    }
  }
}
</script>

<style scoped lang="scss">
  $main-color: #be2316;
.notice-wrap {
  background-color: #ffffff;
  padding: 40px 40px 20px 40px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  .notice-header {
    padding-bottom: 30px;
    .notice-header-title {
      font-size: 24px;
      /*font-weight: bold;*/
      color: #333333;
      text-align: center;
      padding-bottom: 20px;
    }
    .notice-header-time {
      font-size: 14px;
      text-align: center;
      color: #999999;
    }
  }
  .notice-con {
    color: #555555;
    font-size: 14px;
    .notice-con-item{
      .item-txt{
        padding-bottom: 10px;
      }
      .item-title{
        padding-bottom: 10px;
        font-size: 15px;
        text-align: center;
      }
    }
  }
  .notice-btn-box {
    width: 100%;
    height: auto;
    text-align: center;
    .notice-btn {
      display: inline-block;
      width: 136px;
      height: 40px;
      line-height: 40px;
      background: #be2316;
      color: #fff;
      font-size: 18px;
      text-align: center;
      border-radius: 4px;
      margin-top: 50px;
      cursor: pointer;
      margin-right: 15px;
    }
    .notice-btn-return {
      display: inline-block;
      width: 136px;
      height: 40px;
      line-height: 40px;
      background: #be2316;
      color: #fff;
      font-size: 18px;
      text-align: center;
      border-radius: 4px;
      margin-top: 50px;
      cursor: pointer;
    }
  }
}
  /*推荐联系人*/
  .recommendLog-wrap{
    .recommendLog-title {
      color: $main-color;
      font-weight: bold;
      width: 100%;
      height: 51px;
      background: #EEEFF1;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
      border-radius: 4px;
      margin-top: 10px;
      ul {
        display: flex;
        flex-wrap: nowrap;
        line-height: 51px;
        box-sizing: content-box;
        li {
          font-size: 14px;
          min-width: 50px;
          margin: auto auto;
          text-align: center;
          color: #BE2316;
          -webkit-box-sizing: border-box;
          -moz-box-sizing: border-box;
          box-sizing: border-box;
          &:first-child {
            flex-basis: 5%;
          }
          &:nth-child(2) {
            flex-basis: 20%;
          }
          &:nth-child(3) {
            flex-basis: 20%;
          }
          &:nth-child(4) {
            flex-basis: 15%;
          }
          &:nth-child(5) {
            flex-basis: 15%;
          }
          &:nth-child(6) {
            flex-basis: 20%;
          }
        }
      }
    }
    .recommendLog-body {
      position: relative;
      height: 420px;
      overflow: auto;
      .body-item {
        width: 100%;
        height: auto;
        background: rgba(255, 255, 255, 1);
        border-bottom:1px solid rgba(166,166,166,0.3);
        position: relative;
        box-sizing: border-box;
        ul {
          display: flex;
          flex-wrap: nowrap;
          line-height: 51px;
          box-sizing: content-box;
          /**::selection {*/
          /*background-color: rgba(0, 0, 0, 0) !important;*/
          /*}*/
          li {
            font-size: 14px;
            min-width: 50px;
            margin: auto auto;
            text-align: center;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            &:first-child {
              flex-basis: 5%;
            }
            &:nth-child(2) {
              flex-basis: 20%;
              color: #333;
            }
            &:nth-child(3) {
              flex-basis: 20%;
              color: #333;
            }
            &:nth-child(4) {
              flex-basis: 15%;
              color: #555;
            }
            &:nth-child(5) {
              flex-basis: 15%;
            }
            &:nth-child(6) {
              flex-basis: 20%;
            }
          }
        }
        /deep/ .goods-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
  }
</style>
